import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/global';

@Component({
  selector: 'app-under-contract',
  templateUrl: './under-contract.component.html',
  styleUrls: ['./under-contract.component.scss']
})
export class UnderContractComponent implements OnInit {


  constructor(public globals: Globals) { }

  section_modal: string = '';

  ngOnInit() {
    var modal=this.globals.getModalValue();
    if(undefined!=modal){
      this.section_modal=modal;
    }
  }

  setValue(value) {
    this.globals.setValue(value);
  }
}
